module.exports = __webpack_public_path__ + "img/img53.242086dd.png";